import { useState, useEffect, useRef, useMemo } from "react";
import {
  Page,
  Navbar,
  BtnSmallDisabled,
  DialogBox,
  BtnSmall,
  IconBtn,
  PopUp,
  Loader
} from "../components";
import {
  Link as RouterLink,
  useParams,
  useNavigate,
  useLocation
} from "react-router-dom";
import * as ROUTES from "../constant/routes";
import {
  addBooksInCart,
  deleteAllBooksInCart,
  getAllBooksInCart,
  getAllAccessCodes,
  removeABookInCart,
  updateQuantity,
  updateValidity,
  payForAccessIds,
  verifyOtp,
  wallet
} from "../assets/Js/script";
import Timeout from "../helpers/Timeout";
import { tr } from "date-fns/locale";
import { set } from "date-fns";
import { ToastContainer, toast } from "react-toastify";
import { Menu } from "@headlessui/react";
import CustomDropDown from "../components/CustomDropDown";
import CartBookCard from "./components/CartBookCard";

export default function GenerateAccessIds() {
  const navigate = useNavigate();

  const [accessIdCreated, setAccessIdCreated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentAccessCodes, setCurrentAccessCodes] = useState([]);
  const [accesIdDetails, setAccesIdDetails] = useState([]);
  const [bookDetails, setBookDetails] = useState([]);
  const [accessCodeCharges, setAccessCodeCharges] = useState();
  const [walletDetails, setWalletDetails] = useState(null);
  const [miniLoader, setMiniLoader] = useState(false);
  const [paid, setPaid] = useState(false);
  const [otps, setOtps] = useState(new Array(6).fill(""));
  const [totalCharges, setTotalCharges] = useState();
  const [modals, setModals] = useState({
    payment: false,
    commissionCost: false,
    hamburger: false,
    validity: false,
    confirmCartEmpty: false
  });

  const getBooks = async () => {
    setLoading(true);
    const { response, error } = await getAllBooksInCart("accessId");
    if (response.status === "success") {
      console.log(response);
      setBookDetails([...response.data.bookData]);

      setAccesIdDetails([...response.data.allBooks]);
      setCurrentAccessCodes([...response.data.currentAccessCodes]);
    }
    setLoading(false);
  };

  async function getWallet() {
    const { response, error } = await wallet();
    if (response.status === "success") {
      setWalletDetails({ ...response.data });
    }
  }

  const validityUpdateHandler = async (cartId, validity) => {
    console.log(validity, "vvv");
    const { response, error } = await updateValidity(cartId, validity, true);
    let tmpAccessIdDetails = [...accesIdDetails];
    accesIdDetails.forEach((aid, idx) => {
      if (aid.id == cartId) {
        tmpAccessIdDetails[idx].validity = Number(validity);
      }
    });
    setAccesIdDetails([...tmpAccessIdDetails]);

    if (response.status === "success") {
    } else {
      toast(response?.message ? response?.message : "Something went wrong");
    }
  };
  async function handlePayment() {
    setMiniLoader(true);
    setOtps([...otps.map((v) => "")]);

    const { response, error } = await payForAccessIds(parseFloat(totalCharges));
    if (response.status === "success") {
      setMiniLoader(false);
      setPaid(true);
    } else {
      setMiniLoader(false);
      toast(response?.message ? response?.message : "Something went wrong");
    }
  }
  async function otpVerification() {
    setMiniLoader(true);
    const { response, error } = await verifyOtp(otps.join(""), true);
    if (response.status === "success") {
      setAccessIdCreated(true);
      setMiniLoader(false);
    } else {
      toast(response?.message ? response?.message : "Something went wrong");
      setMiniLoader(false);
      setOtps([...otps.map((v) => "")]);
    }
  }
  async function updateCartDetails(cartId, numberOfCopies, qrCodes) {
    // setModals((prev) => ({...prev, loader: true}));
    // return
    const { response, error } = await updateQuantity(
      cartId,
      Number(numberOfCopies),
      true,
      qrCodes
    );
    if (response.status === "success") {
      // setModals((prev) => ({ ...prev, loader: false }));
    } else {
      toast(response?.message ? response?.message : "Something went wrong");
    }
  }

  function handleChnges(data, index) {
    if (isNaN(data.value)) {
      return false;
    }
    setOtps([...otps.map((d, idx) => (idx === index ? data.value : d))]);

    // for AutoFocus

    if (data.nextSibling &&data.value ) {
      data.nextSibling.focus();
    }
  }

  const getAccesCodeCharges = async () => {
    const { response, error } = await getAllAccessCodes();
    if (response.status === "success") {
      setAccessCodeCharges([...response.data.charges]);
      console.log(response, "aid charges");
    }
  };
  const handleCharges = (validity, noOfCopies, qrCodeCount) => {
    console.log(
      validity,
      noOfCopies,
      qrCodeCount,
      "validity, noOfCopies , qrCodeCount"
    );
    if (accessCodeCharges) {
      return (
        accessCodeCharges.find((item) => item.validity === validity)
          .priceInToken * Number(noOfCopies)
      );
    } else {
      return "";
    }
  };

  const confirmClickHandler = () => {
    let total = [];
    if (accesIdDetails?.length > 0) {
      accesIdDetails.forEach((book) => {
        total.push(
          accessCodeCharges.find((item) => item.validity === book.validity)
            .priceInToken * Number(book.numberOfCopies)
        );
      });

      if (total.length < 0) return;

      let sum = total?.reduce((prevState, currState) => prevState + currState);
      if (parseFloat(sum) < parseFloat(walletDetails?.myCredits?.credits)) {
        setTotalCharges(sum);
        setModals((prevState) => ({ ...prevState, payment: true }));
      } else {
        toast(
          " Your account balance is insufficient to complete this transaction."
        );
      }
    }
  };

  const PaymentDetails = () => {
    return (
      <div className="">
        <div className="flex flex-col h-fit  bg-neutral-0 border-1 py-4 px-6 border-solid border-primary-gray mb-4">
          <h3 className="text-heading font-semibold h-4 mb-8">
            Payment Details
          </h3>
          <div className="pb-2 border-b border-primary-dark-20">
            {bookDetails.map((book) => (
              <div className="flex items-start ">
                <p className="text-s">{book.title}</p>
                <div className="flex-1" />
                <p className="w-1/10">
                  {accesIdDetails
                    .filter((a) => a.bookId == book.parentId)
                    .reduce(
                      (a, b) =>
                        a +
                        handleCharges(
                          b.validity,
                          b.numberOfCopies,
                          b.qrCodeCount
                        ),
                      0
                    )}
                </p>
              </div>
            ))}
          </div>
          <div></div>
          <div className="mt-3 mb-5 flex items-start justify-between text-h5 text-thumb">
            <p className=" w-9/10 ">Final Tokens</p>
            <p className="w-1/10">
              {accesIdDetails.reduce(
                (a, b) =>
                  a +
                  handleCharges(b.validity, b.numberOfCopies, b.qrCodeCount),
                0
              )}
            </p>
          </div>
          <button
            onClick={confirmClickHandler}
            className="w-full h-[56px] bg-primary-dark text-primary-white text-h5"
          >
            Confirm
          </button>
        </div>
      </div>
    );
  };

  const EmptyCart = () => {
    return (
      <div className="flex flex-col items-center justify-center w-full h-[70%]">
        <svg
          width="101"
          height="92"
          viewBox="0 0 101 92"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M96.1892 39.4297H96.2902C98.0297 39.4297 99.6008 40.1657 100.723 41.3541C101.883 42.5079 102.601 44.1179 102.601 45.9004V46.0077V46.1074C102.601 47.8899 101.883 49.4999 100.723 50.6499C99.5971 51.8382 98.0259 52.5742 96.2865 52.5742H96.1818H95.4336L89.6691 86.5721C89.4251 88.1002 88.6441 89.484 87.4733 90.4629L87.4621 90.4706C86.3773 91.4251 84.9558 92.0077 83.4034 92.0077H19.1861C17.6337 92.0077 16.2122 91.4251 15.1199 90.4629L15.1274 90.4706C13.9604 89.4992 13.1786 88.1256 12.9278 86.6066L12.9241 86.5682L7.15962 52.5704H6.30673C4.56728 52.5704 2.99617 51.8344 1.87395 50.6461C1.27897 50.0564 0.806049 49.3499 0.483411 48.5688C0.160772 47.7877 -0.00496337 46.9479 -0.00390118 46.0997V45.9924V45.8927C-0.00390118 44.1102 0.714321 42.5002 1.87395 41.3502C2.99991 40.1619 4.57102 39.4259 6.31047 39.4259H6.41521H6.41147L96.1892 39.4297ZM24.281 80.5001C24.7007 80.4707 25.1101 80.3535 25.4839 80.1558C25.8577 79.958 26.188 79.6838 26.4544 79.3501L26.4581 79.3462C26.7423 79.0229 26.9581 78.6428 27.092 78.2298C27.2259 77.8168 27.275 77.3799 27.2362 76.9466V76.9581L25.6314 55.5987C25.6028 55.1686 25.4884 54.7491 25.2954 54.366C25.1024 53.983 24.8348 53.6445 24.5092 53.3716L24.5054 53.3677C24.1899 53.0765 23.8189 52.8554 23.4159 52.7181C23.0129 52.5809 22.5866 52.5306 22.1637 52.5704H22.1749C21.7552 52.5998 21.3458 52.7169 20.972 52.9147C20.5982 53.1125 20.2679 53.3867 20.0016 53.7204L19.9978 53.7242C19.7137 54.0476 19.4978 54.4277 19.3639 54.8407C19.23 55.2537 19.1809 55.6906 19.2198 56.1239V56.1124L20.8245 77.4717C20.8779 78.2996 21.2459 79.0731 21.8495 79.6261L21.8532 79.6299C22.4307 80.1916 23.1967 80.5045 23.9929 80.5039H24.0341H24.0304L24.281 80.5001ZM44.8738 77.2187V55.8594V55.8287C44.875 55.4029 44.7913 54.9813 44.6279 54.5898C44.4646 54.1982 44.2249 53.845 43.9236 53.5517C43.6364 53.2433 43.291 52.9979 42.9084 52.8305C42.5258 52.6631 42.1139 52.5772 41.6979 52.5781H41.638C41.2225 52.5768 40.8111 52.6626 40.429 52.83C40.0469 52.9974 39.7022 53.243 39.416 53.5517C39.115 53.846 38.8755 54.2 38.7122 54.5921C38.5488 54.9842 38.465 55.4062 38.4659 55.8326V77.2532C38.4659 78.1502 38.8287 78.9591 39.416 79.5302C39.7032 79.8387 40.0486 80.0841 40.4312 80.2515C40.8139 80.4189 41.2257 80.5048 41.6418 80.5039H41.7016C42.1172 80.5051 42.5286 80.4194 42.9106 80.252C43.2927 80.0846 43.6374 79.839 43.9236 79.5302C44.2287 79.236 44.4718 78.8807 44.6378 78.4865C44.8038 78.0922 44.8892 77.6673 44.8887 77.2379V77.2149L44.8738 77.2187ZM64.1124 77.2187V55.8594V55.8287C64.1136 55.4029 64.0299 54.9813 63.8666 54.5898C63.7032 54.1982 63.4635 53.845 63.1622 53.5517C62.8751 53.2433 62.5297 52.9979 62.147 52.8305C61.7644 52.6631 61.3525 52.5772 60.9365 52.5781H60.8766C60.4611 52.5768 60.0497 52.6626 59.6676 52.83C59.2855 52.9974 58.9408 53.243 58.6546 53.5517C58.3536 53.846 58.1141 54.2 57.9508 54.5921C57.7875 54.9842 57.7037 55.4062 57.7045 55.8326V77.2532C57.7045 78.1502 58.0674 78.9591 58.6546 79.5302C58.9418 79.8387 59.2872 80.0841 59.6699 80.2515C60.0525 80.4189 60.4643 80.5048 60.8804 80.5039H60.9402C61.3558 80.5051 61.7672 80.4194 62.1493 80.252C62.5313 80.0846 62.876 79.839 63.1622 79.5302C63.4674 79.236 63.7104 78.8807 63.8764 78.4865C64.0424 78.0922 64.1278 77.6673 64.1273 77.2379V77.2149L64.1124 77.2187ZM81.7462 77.4717L83.351 56.1124C83.3872 55.6804 83.3369 55.2454 83.2031 54.8341C83.0693 54.4227 82.8548 54.0437 82.5729 53.7204L82.5767 53.7242C82.311 53.3901 81.9815 53.1151 81.6084 52.916C81.2354 52.717 80.8265 52.598 80.4071 52.5666H80.3958C79.9743 52.5295 79.5498 52.5811 79.1484 52.7182C78.747 52.8553 78.3771 53.075 78.0616 53.3639L78.0653 53.3601C77.7393 53.6324 77.4709 53.97 77.2767 54.3523C77.0824 54.7346 76.9664 55.1535 76.9356 55.5834V55.5949L75.3309 76.9542C75.2947 77.3862 75.345 77.8213 75.4788 78.2326C75.6126 78.6439 75.827 79.0229 76.1089 79.3462L76.1052 79.3424C76.3709 79.6765 76.7004 79.9516 77.0735 80.1506C77.4465 80.3497 77.8553 80.4686 78.2748 80.5001H78.5741C79.3713 80.5001 80.1383 80.1873 80.7175 79.6261C81.3288 79.0737 81.7037 78.2972 81.7612 77.4641V77.4526L81.7462 77.4717ZM23.8471 14.9884L19.1898 36.1407H12.5762L17.6337 13.5011C18.2434 10.4919 19.8407 7.94274 22.0552 6.16024L22.0814 6.14108C24.31 4.28909 27.0939 3.28175 29.9632 3.28908H30.1053H30.0978H38.4621V3.25841C38.4621 2.36141 38.825 1.55258 39.4123 0.98141C39.6997 0.671937 40.0456 0.425671 40.4289 0.257618C40.8122 0.0895639 41.2249 0.00324152 41.6418 0.0039101H60.9515C61.8268 0.0039101 62.6161 0.375743 63.1735 0.977577C63.4745 1.27185 63.714 1.62581 63.8773 2.01791C64.0407 2.41002 64.1245 2.83207 64.1236 3.25841V3.28908H72.6263C75.6227 3.28908 78.3721 4.36241 80.5268 6.15641L80.5043 6.13724C82.7735 7.95202 84.3436 10.5304 84.9371 13.4167L84.952 13.4972L90.0095 36.1369H83.3959L78.7387 14.9846C78.4001 13.533 77.6032 12.2366 76.4718 11.2969L76.4606 11.2854C75.3596 10.3537 73.9756 9.84524 72.5478 9.84791H64.1124V9.87858C64.1136 10.3044 64.0299 10.726 63.8666 11.1175C63.7032 11.5091 63.4635 11.8623 63.1622 12.1556C62.8751 12.4641 62.5297 12.7095 62.147 12.8769C61.7644 13.0442 61.3525 13.1301 60.9365 13.1292H41.6418C41.2262 13.1305 40.8148 13.0448 40.4327 12.8773C40.0507 12.7099 39.706 12.4643 39.4198 12.1556C39.1187 11.8613 38.8792 11.5073 38.7159 11.1152C38.5526 10.7231 38.4688 10.3011 38.4696 9.87474V9.84408H30.0342C28.603 9.84242 27.2162 10.3536 26.1139 11.2892L26.1252 11.2816C25.0019 12.2138 24.2093 13.4989 23.8695 14.9386L23.862 14.9846L23.8471 14.9884Z"
            fill="#726D6D"
            fillOpacity="0.33"
          />
        </svg>
        <p className="text-secondary-light text-montserrat font-semibold leading-[29px] text-h1">
          Your cart is empty.
        </p>
      </div>
    );
  };

  useEffect(() => {
    getBooks();
    getAccesCodeCharges();
    getWallet();
  }, []);

  return (
    <Page active="wallet">
      <Navbar />
      {loading ? (
        <Loader show={loading} />
      ) : (
        <div>
          <h1 className="mb-5 flex items-center text-mobile-h1  lg:text-h1 text-tertiary-dark lg:text-heading text-left font-bold lg:font-semibold">
            <span onClick={() => navigate(-1)} className=" mr-3">
              <svg
                width="12"
                height="20"
                viewBox="0 0 12 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="cursor-pointer"
              >
                <path
                  d="M11.0491 2.5473L9.4174 0.924805L0.351562 9.9998L9.42656 19.0748L11.0491 17.4523L3.59656 9.9998L11.0491 2.5473Z"
                  fill="#702963"
                />
              </svg>
            </span>
            Create AccessIDs or QRIDs for Books
          </h1>

          {bookDetails.length ? (
            <div className="flex">
              <div className="w-4/6">
                {console.log(bookDetails, "bookdetails")}
                {bookDetails.map((book) => (
                  <CartBookCard
                    key={book.parentId}
                    book={book}
                    accesIdDetails={accesIdDetails}
                    setBookDetails={setBookDetails}
                    updateCartDetails={updateCartDetails}
                    setAccesIdDetails={setAccesIdDetails}
                    currentAccessCodes={currentAccessCodes}
                    validityUpdateHandler={validityUpdateHandler}
                    handleCharges={handleCharges}
                    toast={toast}
                  />
                ))}
              </div>

              <div className="w-2/6 ml-3">
                <PaymentDetails />
              </div>
            </div>
          ) : (
            <EmptyCart />
          )}
        </div>
      )}

      {modals.payment && (
        <DialogBox show={modals.payment}>
          <div className="bg-primary-white flex flex-col justify-between relative">
            <div className=" border-[1.5px] border-solid border-primary-dark-10 p-6  w-[902px] h-[370px]">
              {!paid ? (
                <>
                  <h2 className="text-heading font-semibold text-left mb-4">
                    Payment Details
                  </h2>
                  {/* <p className="text-secondary-light text-h5 text-justify mb-4">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        At aliquet ut facilisi nulla mauris iopsum. Pipsum dolor
                        sit ametre, consectetur adipiscing elit. At aliquet ut
                        facilisi nulla mauris.
                      </p> */}
                  <div className="flex items-center pl-4 mb-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                    <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                      &#8377;
                    </div>
                    <p className="text-h5 text-secondary-dark font-semibold">
                      Total Tokens Available:{" "}
                      <span className="text-heading  ml-6">
                        {Math.floor(walletDetails.myCredits.credits)}
                      </span>
                    </p>
                  </div>
                  <div className="mb-4 flex items-center pl-4 border-[1.5px] border-solid border-primary-dark-10 w-[730px] h-12">
                    <div className="w-6 h-6 text-white font-semibold bg-secondary-yellow flex justify-center items-center rounded-sm mr-3">
                      &#8377;
                    </div>
                    <p className=" text-h5 text-secondary-dark font-semibold">
                      Amount to pay:{" "}
                      <span className="text-heading  ml-[73px]">
                        {totalCharges}
                      </span>
                    </p>
                  </div>
                  {/* {inSufficientBalance && (
                        <p className="flex items-center text-secondary-light text-h5 text-left mb-2">
                          <span className="mr-2">
                            <svg
                              width="25"
                              height="22"
                              viewBox="0 0 25 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0265 0C5.39521 0 0 4.85983 0 10.8333C0 16.8068 5.42058 21.6667 12.0833 21.6667C18.7461 21.6667 24.1667 16.8068 24.1667 10.8333C24.1667 4.85983 18.7207 0 12.0265 0ZM13.2917 16.25H10.875V14.0833H13.2917V16.25ZM13.2917 11.9167H10.875V5.41667H13.2917V11.9167Z"
                                fill="#FF3737"
                              />
                            </svg>
                          </span>
                          Your account balance is insufficient to complete this
                          transaction.
                          <RouterLink
                            to={ROUTES.WALLET}
                            className="ml-2 font-semibold text-tertiary-dark underline"
                          >
                            Add Money
                          </RouterLink>
                        </p>
                      )} */}
                  {
                    // inSufficientBalance ? (
                    //   <div className="flex justify-end">
                    //     <BtnSmallDisabled
                    //       onClick={() =>
                    //         setModals((prevState) => ({
                    //           ...prevState,
                    //           addNew: false,
                    //         }))
                    //       }
                    //     >
                    //       Pay
                    //     </BtnSmallDisabled>
                    //   </div>
                    // ) :
                    <div className="flex justify-end mt-10">
                      <BtnSmall
                        onClick={() => {
                          setModals((prevState) => ({
                            ...prevState,
                            addNew: false
                          }));
                          handlePayment();
                        }}
                      >
                        {miniLoader ? (
                          <div className="flex">
                            <svg
                              className="animate-spin ml-1 mr-3 h-5 w-5 "
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                class="opacity-20"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Processing...
                          </div>
                        ) : (
                          "Pay"
                        )}
                      </BtnSmall>
                    </div>
                  }
                </>
              ) : (
                <>
                  <h2 className="text-heading font-semibold text-left mb-4">
                    Authorise Payment
                  </h2>
                  <p className="text-secondary-light text-h5 text-justify mb-8">
                    OTP has been sent to your registered mobile number and email
                    address. Please authorize the payment with the OTP.
                  </p>
                  <div className="flex items-center mb-8">
                    {otps.map((element, index) => {
                      return (
                        <input
                          type="text"
                          key={index}
                          onChange={(e) => handleChnges(e.target, index)}
                          value={element}
                          name="otp"
                          maxLength="1"
                          onFocus={(e) => e.target.select()}
                          autoFocus={index === 0}
                          className="font-semibold text-heading text-h1 text-center mr-[19px] rounded-lg bg-primary-white w-[61.16px] h-[54px] border-1 border-solid border-[rgba(239, 239, 238, 0.9)] shadow-[0_3px_4px_3px_rgba(99,99,99,0.11)]"
                        />
                      );
                    })}
                  </div>

                  <p className="mb-6 text-left text-heading-false font-semibold text-p1">
                    Didn't receive the OTP?{" "}
                    <span className="text-secondary-light underline">
                      <Timeout handleClick={handlePayment} start={60} />
                    </span>
                  </p>

                  {otps[5] === "" ? (
                    <div className="ml-auto text-right">
                      <BtnSmallDisabled
                        onClick={() =>
                          setModals((prevState) => ({
                            ...prevState,
                            addNew: false
                          }))
                        }
                      >
                        Submit
                      </BtnSmallDisabled>
                    </div>
                  ) : (
                    <div className="flex justify-end text-right">
                      <BtnSmall
                        onClick={() => {
                          setModals((prevState) => ({
                            ...prevState,
                            addNew: false
                          }));
                          otpVerification();
                        }}
                      >
                        {miniLoader ? (
                          <div className="flex">
                            <svg
                              className="animate-spin ml-1 mr-3 h-5 w-5 "
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                class="opacity-20"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                class="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                            Processing...
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </BtnSmall>
                    </div>
                  )}
                </>
              )}
            </div>
            <button
              onClick={() => {
                setModals((prevState) => ({ ...prevState, payment: false }));
                setOtps([...otps.map((v) => "")]);
                // setInSufficientBalance(false);
                setPaid(false);
                setMiniLoader(false);
              }}
              className="absolute top-8 right-8"
            >
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.2176 12.8188C10.9475 13.0888 10.5813 13.2405 10.1994 13.2405C9.81747 13.2405 9.45122 13.0888 9.18117 12.8188L5.99997 9.18281L2.81877 12.8176C2.68545 12.9531 2.52663 13.0609 2.35145 13.1347C2.17628 13.2085 1.98823 13.2469 1.79814 13.2477C1.60805 13.2485 1.41969 13.2116 1.24392 13.1392C1.06815 13.0668 0.908454 12.9604 0.77404 12.8259C0.639626 12.6915 0.533155 12.5318 0.460769 12.3561C0.388382 12.1803 0.351512 11.9919 0.352286 11.8018C0.35306 11.6118 0.391462 11.4237 0.465278 11.2485C0.539094 11.0734 0.646862 10.9145 0.782367 10.7812L4.09197 7.00121L0.781167 3.21881C0.645662 3.0855 0.537894 2.92667 0.464078 2.7515C0.390263 2.57633 0.35186 2.38827 0.351086 2.19818C0.350312 2.00809 0.387182 1.81973 0.459569 1.64397C0.531955 1.4682 0.638426 1.3085 0.77284 1.17409C0.907255 1.03967 1.06695 0.933201 1.24272 0.860814C1.41849 0.788427 1.60685 0.751557 1.79694 0.752331C1.98703 0.753105 2.17508 0.791508 2.35025 0.865323C2.52543 0.939139 2.68425 1.04691 2.81757 1.18241L5.99997 4.81961L9.18117 1.18241C9.31448 1.04691 9.47331 0.939139 9.64848 0.865323C9.82365 0.791508 10.0117 0.753105 10.2018 0.752331C10.3919 0.751557 10.5802 0.788427 10.756 0.860814C10.9318 0.933201 11.0915 1.03967 11.2259 1.17409C11.3603 1.3085 11.4668 1.4682 11.5392 1.64397C11.6116 1.81973 11.6484 2.00809 11.6476 2.19818C11.6469 2.38827 11.6085 2.57633 11.5347 2.7515C11.4608 2.92667 11.3531 3.0855 11.2176 3.21881L7.90797 7.00121L11.2176 10.7812C11.3515 10.915 11.4577 11.0738 11.5301 11.2486C11.6026 11.4234 11.6399 11.6108 11.6399 11.8C11.6399 11.9893 11.6026 12.1766 11.5301 12.3514C11.4577 12.5263 11.3515 12.6851 11.2176 12.8188Z"
                  fill="black"
                  fillOpacity="0.53"
                />
              </svg>
            </button>
          </div>
        </DialogBox>
      )}
      {accessIdCreated && (
        <DialogBox show={accessIdCreated}>
          <PopUp
            height={true}
            onClick={() => {
              setAccessIdCreated(false);
              navigate(ROUTES.CATALOGUE);
            }}
            onClose={() => {
              setAccessIdCreated(false);
              // navigate(ROUTES.CATALOGUE);
            }}
            title="Access Ids created"
            main={`You have successfully added access id`}
            button="Go To Catalogue"
          />
        </DialogBox>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover
      />
    </Page>
  );
}
